import swal from 'sweetalert2'
import api from '../../models/locationlink'
import addLocationlinkModal from '../../components/modal/llk_add_modal'
import editLocationlinkModal from '../../components/modal/llk_edit_modal'

export default {
  name: 'locationlink',
  components: {
    addLocationlinkModal,
    editLocationlinkModal,
  },
  data() {
    return {
      search_text: '',
      per_page: 100,
      active_page: 1,
      is_load: false,
      result_data: {
        pagination: [],
        count: 0,
      },
      modal_type: '',
      add_modal_data: {
        ps_id: 0,
        shelf_code: '',
      },
      edit_modal_data: {
        llk_id: 0,
        shelf_code: '',
        selected: {
          ps_id: 0,
          dk_code: '',
          pr_number: '',
          pr_name: '',
          spl_code: '',
        },
      },
      check_all: false,
      llk_ids: [],
      print_data: '',
      export_data: '',
      print_mode: '',
    }
  },
  methods: {
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    activePage(value) {
      this.active_page = value
      this.search()
    },
    search() {
      this.is_load = true
      var obj = {
        search: this.search_text,
        page: this.active_page,
        limit: this.per_page,
      }
      this.result_data.pagination = []
      this.result_data.count = 0
      this.header.params = obj
      // reset print
      this.check_all = false
      this.llk_ids = []
      this.print_data = ''
      api.searchLocationlink(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.result_data.pagination = result.data.pagination
            this.result_data.count = result.data.count
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
          this.is_load = false
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
          this.is_load = false
        }
      )
    },
    addLocationlinkModal() {
      this.modal_type = 'add'
      this.add_modal_data = {
        shelf_code: '',
        ps_id: 0,
      }
      this.ModalBoots('llk_modal').show()
    },
    editLocationlinkModal(obj) {
      this.modal_type = 'edit'
      this.edit_modal_data = {
        llk_id: obj.llk_id,
        shelf_code: obj.llk_shelf_code,
        ps_id: obj.ps_id ? obj.ps_id : 0,
        dk_code: obj.dk_code ? obj.dk_code : '',
        pr_number: obj.pr_number ? obj.pr_number : '',
        pr_name: obj.pr_name ? obj.pr_name : '',
        spl_code: obj.spl_code ? obj.spl_code : '',
      }
      this.ModalBoots('llk_modal').show()
    },
    deleteLocationLinkModal(obj) {
      swal
        .fire({
          title: 'Are you sure?',
          text: 'Confirm delete Location Link : ' + obj.llk_shelf_code,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#67757c',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'Cancel',
        })
        .then((result) => {
          if (result.value) {
            api.deleteLocationlink(
              this.$store.state.URLHost,
              obj.llk_id,
              this.header,
              (result) => {
                if (result.response === true) {
                  this.alert_msg('success', 'Successful.', result.message)
                } else {
                  this.alert_msg('error', 'An error occurred.', result.message)
                }
                this.search()
              },
              (error) => {
                this.alert_msg('error', 'An error occurred.', error.message)
                this.search()
              }
            )
          }
        })
    },
    printPdf(llk_id, print_mode) {
      // this.is_load = true
      if (llk_id === '') {
        this.header.params = {
          llk_ids: this.llk_ids.join(','),
        }
      } else {
        this.header.params = {
          llk_ids: llk_id,
        }
      }
      this.print_data = ''
      api.printLocationlink(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.print_data = JSON.stringify(result.data.print_data)
            if (print_mode === '1') {
              this.print_mode =
                this.$store.state.URLBase + '/static/pdf/shelfcode_a4_pdf.php'
            } else if (print_mode === '11') {
              this.print_mode =
                this.$store.state.URLBase +
                '/static/pdf/shelfcode_a4_pdf.php?mode=black'
            } else if (print_mode === '111') {
              this.print_mode =
                this.$store.state.URLBase +
                '/static/pdf/shelfcode_a4_pdf.php?mode=grey'
            } else if (print_mode === '2') {
              this.print_mode =
                this.$store.state.URLBase + '/static/pdf/shelfcode_a7_pdf.php'
            } else if (print_mode === '22') {
              this.print_mode =
                this.$store.state.URLBase +
                '/static/pdf/shelfcode_a7_pdf.php?mode=black'
            } else if (print_mode === '222') {
              this.print_mode =
                this.$store.state.URLBase +
                '/static/pdf/shelfcode_a7_pdf.php?mode=grey'
            } else if (print_mode === '3') {
              this.print_mode =
                this.$store.state.URLBase + '/static/pdf/shelfcode_a7s_pdf.php'
            } else {
              this.print_mode =
                this.$store.state.URLBase +
                '/static/pdf/shelfcode_a7s_pdf.php?mode=black'
            }
            setTimeout(() => {
              this.$refs.print_pdf.submit()
            }, 1000)
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
          // this.is_load = false
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
          // this.is_load = false
        }
      )
    },
    exportExcel() {
      // this.is_load = true
      var obj = {
        search: this.search_text,
      }
      this.export_data = ''
      this.header.params = obj
      api.exportLocationlink(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.export_data = JSON.stringify(result.data.export_data)
            setTimeout(() => {
              this.$refs.export_excel.submit()
            }, 1000)
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
          // this.is_load = false
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
          // this.is_load = false
        }
      )
    },
    checkAll() {
      this.llk_ids = []
      if (!this.check_all) {
        for (let llk in this.result_data.pagination) {
          this.llk_ids.push(this.result_data.pagination[llk].llk_id)
        }
      }
    },
  },
  created() {
    this.checkOAuth()
  },
  mounted() {
    setTimeout(() => {
      if (sessionStorage.token) {
        this.activePage(1)
      } else {
        setTimeout(() => {
          this.activePage(1)
        }, 1000)
      }
    }, 1000)
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/locationlink.js